/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTI1p3Provider } from './BaseLTI1p3Provider';
const NonFinalizedLTI1p3ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['finalized', /* #__PURE__ */ parsers.exactly(false)],
    ['netloc', codecString],
    [
        'authLoginUrl',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'auth_login_url',
    ],
    [
        'authTokenUrl',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'auth_token_url',
    ],
    ['clientId', /* #__PURE__ */ parsers.maybeNull(codecString), 'client_id'],
    [
        'keySetUrl',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'key_set_url',
    ],
    [
        'authAudience',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'auth_audience',
    ],
    [
        'customFields',
        /* #__PURE__ */ codec.record(codecString, codecString),
        'custom_fields',
    ],
    [
        'publicJwk',
        /* #__PURE__ */ codec.record(codecString, codecString),
        'public_jwk',
    ],
    ['publicKey', codecString, 'public_key'],
    [
        'editSecret',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'edit_secret',
    ],
])), BaseLTI1p3Provider);
export class NonFinalizedLTI1p3Provider extends BaseLTI1p3Provider {
    static decode(input) {
        return NonFinalizedLTI1p3ProviderParser.decode(input).map(res => new NonFinalizedLTI1p3Provider(res));
    }
    static unsafeDecode(input) {
        return NonFinalizedLTI1p3Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NonFinalizedLTI1p3ProviderParser.encode(data);
    }
    static schema() {
        return NonFinalizedLTI1p3ProviderParser.schema();
    }
}
